import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getName, uploadProfilePic, getProfilePic } from '../Actions'
import { useUsers } from '../UserContext'
import EditProfile from './EditProfile'
import genericProfilePic from '../genericprofilepic.png'
import { formatLocation } from '../utils/format'
import { toast } from 'react-hot-toast'

export const SET_PROFILE_PIC = 'SET_PROFILE_PIC'
export const GET_PROFILE_PIC = 'GET_PROFILE_PIC'

function MyProfile({ getProfilePic, getName, uploadProfilePic, profile_pic_url }) {
    const [userId, setUserId] = useState('')
    const [editProfile, setEditProfile] = useState(false)
    const { users, fetchUsers } = useUsers()
    const [uploading, setUploading] = useState(false)

    const handleUpload = async () => {
        const input = document.querySelector('input.upload-img')
        if (!input?.files?.[0]) {
            toast.error('Choose a picture first.')
            return
        }
        setUploading(true)
        const ok = await uploadProfilePic()
        setUploading(false)
        if (ok) {
            input.value = ''
            toast.success('Profile picture updated!')
            fetchUsers()
        } else {
            toast.error('Upload failed. Please try again.')
        }
    }

    useEffect(() => {
        const id = localStorage.getItem("user_id")
        setUserId(id)
        getName(id)
    }, [editProfile, getName])

    useEffect(() => {
        getProfilePic(userId)
    }, [userId, getProfilePic])

    return (
        <div>
            <br /><br />
            <h2>My Profile</h2>
            <br /><br />
            {profile_pic_url ?
                <img src={profile_pic_url} id="profilepic" alt="User's Profile" />
                : <img id="genericProfilePic" src={genericProfilePic} alt="Generic Profile" />
            }
            <form>
                <input type="file" accept="image/*" className="upload-img" /><br />
                <button type="button" className="brownroundbutton" onClick={handleUpload} disabled={uploading}>
                    {uploading ? 'Uploading…' : 'Upload Photo'}
                </button>
            </form>
            <br />
            {users.map(user => {
                if (user.id === userId) {
                    return (
                        editProfile ?
                            <EditProfile key={user.id} user={user} setEditProfile={setEditProfile} />
                            :
                            <div key={user.id}>
                                <div className="roundedbox4">
                                    <p className="profiletext">
                                        <b>Name:</b>
                                        <br />
                                        {user.first_name} {user.last_name}
                                    </p>
                                </div>
                                <div className="roundedbox4">
                                    <p className="profiletext">
                                        <b>Location:</b>
                                        <br />
                                        {formatLocation(user) || <i>Not set</i>}
                                    </p>
                                </div>
                                <div className="roundedbox4">
                                    <div className="profiletext">
                                        <b>Bio:</b>
                                        <br />
                                        <p className="commentary-text">{user.bio || <i>Not set</i>}</p>
                                    </div>
                                </div>
                                <button className="brownroundbutton" onClick={() => setEditProfile(true)}>Edit Profile</button>
                                <br />
                                <br />
                            </div>
                    )
                }
                return null;
            })}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        first_name: state.first_name,
        last_name: state.last_name,
        profile_pic_url: state.profile_pic_url,
        profile_pic_alt: state.profile_pic_alt
    }
}

export default connect(mapStateToProps, { getName, uploadProfilePic, getProfilePic })(MyProfile)
